import { OrderHistory } from '../../order-history/order-history.interface';
import { getUTCAsLocalDate } from '../../../common/utils/date-utils';
import { isShopOrder } from '../../../common/utils/order-util';

/**
 * Get the eligible through date for the return.
 * This is the date displayed in the UI, as per the MHE return policy.
 *
 * @param order
 */
export function getReturnEligibleThrough(order: OrderHistory): string {
  return order.returnInfo?.eligibleThrough
    ? getUTCAsLocalDate(order.returnInfo.eligibleThrough).toString()
    : _getDefaultEligibleThrough(order);
}

/**
 * Get the return through date for the return.
 * This is the actual final date for the automatic return, which is an extension of the eligible date.
 * After this date, the return request needs to be approved by the customer service.
 *
 * @param order
 */
export function getReturnThrough(order: OrderHistory): string {
  return order.returnInfo?.returnThrough
    ? getUTCAsLocalDate(order.returnInfo.returnThrough).toString()
    : _getDefaultReturnThrough(order);
}

/**
 * Get the default eligible through date for the return (14 days).
 *
 * @param order
 */
function _getDefaultEligibleThrough(order: OrderHistory): string {
  const orderDate = _getOrderDate(order);
  orderDate.setDate(orderDate.getDate() + 14);
  return orderDate.toString();
}

/**
 * Get the default return through date for the return (60 days).
 *
 * @param order
 */
function _getDefaultReturnThrough(order: OrderHistory): string {
  const orderDate = _getOrderDate(order);
  orderDate.setDate(orderDate.getDate() + 60);
  return orderDate.toString();
}

/**
 * Get the order date from the order history.
 * If the order is a Shop order (ET time), it returns the date as-is.
 * If the order is a Magento order (UTC time), it converts it to a local time date.
 *
 * @param order
 */
function _getOrderDate(order: OrderHistory): Date {
  if (isShopOrder(order)) {
    return new Date(order.orderedDate);
  }

  return getUTCAsLocalDate(order.orderedDate);
}
